import React, { useEffect, useRef } from "react";
import { useDispatch } from "react-redux";
import { View } from "react-native";
import { ActivityIndicator } from "react-native-paper";
import { didTryAutoLogin, loginSuccess, logout } from "../../redux/auth/authActions";
import { expo } from "../../../../../app.json";
import { getSecureStorage, saveSecureStorage } from "../../utils/storage";
import { Icon, Particles, Text } from "@edgelogistics/edge-ui/lib/components";
import { getUserInformation } from "../../redux/profile/profileActions";

const Splash: React.FC = () => {
  const dispatch = useDispatch();
  const time1 = useRef<number>();
  const time2 = useRef<number>();

  useEffect(() => {
    const tryLogin = async () => {
      const user = (await getSecureStorage("user")) || {};

      saveSecureStorage(false, "refresh");
      const { refresh_expires_in, access_token } = user;

      if (Date.now() >= refresh_expires_in) {
        dispatch(logout());

        return;
      }
      if (access_token) {
        time1.current = window.setTimeout(() => {
          dispatch(didTryAutoLogin());
          dispatch(loginSuccess(user));
          dispatch(getUserInformation());
        }, 2000);

        return;
      }
      time2.current = window.setTimeout(() => {
        dispatch(loginSuccess(user));
      }, 1000);
    };

    tryLogin();

    return () => {
      if (time1.current) {
        clearTimeout(time1.current);
      }
      if (time2.current) {
        clearTimeout(time2.current);
      }
    };
  }, [ dispatch ]);

  return (
    <View style={{ flex: 1 }}>
      <Particles>
        <View
          style={{ flex: 12, justifyContent: "center", alignItems: "center" }}
        >
          <Icon
            name="NewEdgeLogo"
            color="#FFF"
            height={120}
            width={200}
            style={{ marginBottom: 20 }}
          />
          <ActivityIndicator
            color="#FFF"
            accessibilityComponentType={null}
            accessibilityTraits={null}
          />
        </View>
        <View
          style={{ flex: 1, justifyContent: "center", alignItems: "center" }}
        >
          <Text color="#FFF" text={`v${expo.version}`} />
        </View>
      </Particles>
    </View>
  );
};

export default Splash;
